import { ThirdPartyDraggable } from "@fullcalendar/interaction"

export default {
	name:'model-errors',
	props:{
		userMsg: {
			type: Object,
			required: true,
			default: () => null
		},
	},
	watch:{
		userMsg:function(){
			this.init();
		}
	},
	data () {
		return {
			type:null
		}
	},
	created () {
		this.init();
	},
	methods:{
		init(){
			this.type=this.userMsg.type=='info'?'primary':this.userMsg.type;	
		}
	}
}

